/* eslint-disable import/no-cycle */
/* eslint-disable no-return-assign */
import axiosIns from '@/libs/axios'
import { requestApi } from '@/libs/secret'

export default {
  namespaced: true,
  state: {
    dataScheduling: {
      fields: [
        { key: 'day', label: 'All', stickyColumn: false },
        { key: '12am' },
        { key: '1am' },
        { key: '2am' },
        { key: '3am' },
        { key: '4am' },
        { key: '5am' },
        { key: '6am' },
        { key: '7am' },
        { key: '8am' },
        { key: '9am' },
        { key: '10am' },
        { key: '11am' },
        { key: '12pm' },
        { key: '1pm' },
        { key: '2pm' },
        { key: '3pm' },
        { key: '4pm' },
        { key: '5pm' },
        { key: '6pm' },
        { key: '7pm' },
        { key: '8pm' },
        { key: '9pm' },
        { key: '10pm' },
        { key: '11pm' },
      ],
      fields2: [
        { key: 'day', label: 'All', stickyColumn: false },
        { key: '8am' },
        { key: '9am' },
        { key: '10am' },
        { key: '11am' },
        { key: '12pm' },
        { key: '1pm' },
        { key: '2pm' },
        { key: '3pm' },
        { key: '4pm' },
        { key: '5pm' },
        { key: '6pm' },
        { key: '7pm' },
        { key: '8pm' },
      ],
      items: [],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
    },
    dataRateCard: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        // { key: 'checkbox', label: '' },
        { key: 'channel', label: 'Channel', sortable: true },
        { key: 'volume', label: 'Volume', sortable: true },
        { key: 'remarks', label: 'Remarks', sortable: true },
        { key: 'format', label: 'Format', sortable: true },
        { key: 'methode', label: 'Buying Methode', sortable: true },
        { key: 'pricing', label: 'Pricing', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          1: 'non', 2: 'Active', 3: 'Inactive',
        },
        {
          1: 'none', 2: 'success', 3: 'secondary',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
    },
    bannerLandscapeUrl: '',
    bannerPotraitUrl: '',
    detailCampaign: {},
    dataBudgetUsage: {},
    campaignId: null,
    campaignDetail: {},
    statusApprove: 1,
    statusCampaign: 'all',
    reason: ['ok'],
    listReason: [],
    dailyBudget: [],
  },
  getters: {
    getSchedulingItem: state => state.dataScheduling.items,
    getSchedulingField: state => state.dataScheduling.fields,
    getSchedulingField2: state => state.dataScheduling.fields2,
    getRateCardItem: state => state.dataRateCard.items,
    getRateCardField: state => state.dataRateCard.fields,
    getRateCardStatus: state => state.dataRateCard.status,
    getRateCardPage: state => state.dataRateCard.items.current_page,
    getSortBy: state => state.dataRateCard.sortBy,
    getSortDesc: state => state.dataRateCard.sortDesc,
    getSearch: state => state.dataRateCard.search,
    getStatusApprove: state => state.statusApprove,
    getRateCardDummy: state => state.dataRateCard.rateCardData,

  },
  mutations: {

    SET_DATA_ITEM: (state, value) => (value ? (state.dataRateCard.items = value) : (state.dataRateCard.items = {})),
    SET_LIST_CURRENT_PAGE: (state, value) => (value ? (state.dataRateCard.items.current_page = value) : (state.dataRateCard.items.current_page = 1)),
    SET_LIST_SORT_BY: (state, value) => (value ? (state.dataRateCard.sortBy = value) : (state.dataRateCard.sortBy = '')),
    SET_LIST_SORT_DESC: (state, value) => (value ? (state.dataRateCard.sortDesc = value) : (state.dataRateCard.sortDesc = false)),
    SET_LIST_SEARCH: (state, value) => (value ? (state.dataRateCard.search = value) : (state.dataRateCard.search = '')),
    SET_ITEM_DATA: (state, value) => (value ? (state.dataRateCard.items.data = value) : (state.dataRateCard.items.data = [])),

    SET_DATA_RATECARD_ITEM: (state, value) => (value ? (state.dataRateCard.items = value) : (state.dataRateCard.items = {})),
    SET_RATECARD_CURRENT_PAGE: (state, value) => (value ? (state.dataRateCard.items.current_page = value) : (state.dataRateCard.items.current_page = 1)),
    SET_RATECARD_SORT_BY: (state, value) => (value ? (state.dataRateCard.sortBy = value) : (state.dataRateCard.sortBy = '')),
    SET_RATECARD_SORT_DESC: (state, value) => (value ? (state.dataRateCard.sortDesc = value) : (state.dataRateCard.sortDesc = false)),
    SET_RATECARD_SEARCH: (state, value) => (value ? (state.dataRateCard.search = value) : (state.dataRateCard.search = '')),
    SET_ITEM_DATA_RATECARD: (state, value) => (value ? (state.dataRateCard.items.data = value) : (state.dataRateCard.items.data = [])),
    // SET_FILE_UPLOAD: (state, value) => (value ? (state.upload_msisdn = value) : (state.upload_msisdn = null)),

    SET_DATA_SCHEDULING_ITEM: (state, value) => (value ? (state.dataScheduling.items = value) : (state.dataScheduling.items = [])),
    // SET_DATA_SCHEDULING_FORM: (state, value) => (value ? (state.dataScheduling.form = value) : (state.dataScheduling.form = {})),
  },
  actions: {
    clearTable({ commit }) {
      commit('SET_LIST_CURRENT_PAGE')
      commit('SET_LIST_SORT_BY')
      commit('SET_LIST_SORT_DESC')
      commit('SET_LIST_SEARCH')
      commit('SET_LIST_SEARCH')
    },
    getRateCard({ commit }) {
    // commit('SET_DATA_RATECARD_ITEM')
      // eslint-disable-next-line no-undef
      // const newData = this.getRateCardDummy
      // commit('SET_DATA_RATECARD_ITEM', newData)
      // return newData
      const temstemp = {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [
          {
            id: 1, channel: 'UUSD', volume: 10000000, remarks: '*111*17*5#', format: 'Text + URL', methode: 'CPA', pricing: 4000, status: 2,
          },
          {
            id: 2, channel: 'SMS', volume: 10000000, remarks: 'Max Char 160(LEN)', format: 'Text + URL', methode: 'CPA', pricing: 4000, status: 2,
          },
          {
            id: 3, channel: 'In App Notification', volume: 5000000, remarks: 'Max Char 160(LEN)', format: 'Text Banner + URL', methode: 'CPA', pricing: 4000, status: 2,
          },
          {
            id: 4, channel: 'In Browser Notification', volume: 5000000, remarks: 'Max Char 160(LEN)', format: 'Text + URL', methode: 'CPA', pricing: 4000, status: 2,
          },
          {
            id: 5, channel: 'Digital screen', volume: 5000000, remarks: 'Top banner slot 1 & 2, RFU slot 1&2', format: 'Text + URL', methode: 'CPC', pricing: 4000, status: 2,
          },
          {
            id: 6, channel: 'Flash Message', volume: 5000000, remarks: 'Popup Prime Time Notification', format: 'Text + URL', methode: 'CPC', pricing: 4000, status: 3,
          },
        ],
      }
      commit('SET_DATA_RATECARD_ITEM', temstemp)
    },
    getScheduling({ commit, rootState }) {
      commit('SET_DATA_SCHEDULING_ITEM')
      // console.log(rootState.campaign.formCampaign.scheduling.rate_card_id)
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
        // console.log(rootState.campaign.formCampaign.channel_id, rootState.campaign.formCampaign.method_id, rootState.campaign.formCampaign.bid_price)
        const queryParam = requestApi(`channel_id=${rootState.campaign.formCampaign.channel_id}&buy_method_id=${rootState.campaign.formCampaign.method_id}&start_date=${rootState.campaign.formCampaign.start_date}&end_date=${rootState.campaign.formCampaign.end_date}&bid_price=${rootState.campaign.formCampaign.bid_price}`)
        axiosIns.get(`/rateCard?req=${queryParam.req}`, { headers })
          .then(response => {
            commit('SET_DATA_SCHEDULING_ITEM', response.data.data)
            resolve(response.data.data)
            // console.log(response.data.data, 'data')
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
